// src/components/PageContent.js
import React, { useState } from "react";
import EventList from "./EventList";
import AddEventForm from "./AddEventForm";
import EditEventForm from "./EditEventForm";
import AboutPage from "./AboutPage";
import ContactPage from "./ContactPage";
import AuthPage from "./AuthPage";


export default function PageContent({ currentPage, setCurrentPage, user }) {
  const [selectedEvent, setSelectedEvent] = useState(null);

  return (
    <div>
            {currentPage === "home" && (
        <>
          <EventList
            user={user}
            onSelect={(event) => {
              setSelectedEvent(event);
             /* setDetailsOpen(true);*/
            }}
            onEdit={(event) => {
              setSelectedEvent(event);
              setCurrentPage("editEvent");
            }}
          />


        </>
      )}

      {currentPage === "about" && (
        <div className="container mt-4">
          <button className="btn btn-secondary mb-3" onClick={() => setCurrentPage("home")}>
            &larr; Vissza
          </button>
          <AboutPage />
        </div>
      )}

      {currentPage === "contact" && (
        <div className="container mt-4">
          <button className="btn btn-secondary mb-3" onClick={() => setCurrentPage("home")}>
            &larr; Vissza
          </button>
          <ContactPage />
        </div>
      )}

      {currentPage === "auth" && (
        <div className="container mt-4">
          <button className="btn btn-secondary mb-3" onClick={() => setCurrentPage("home")}>
            &larr; Vissza
          </button>
          <AuthPage onLoginSuccess={() => setCurrentPage("home")} />
        </div>
      )}

      {currentPage === "addEvent" && (
        <div className="container mt-4">
          <button className="btn btn-secondary mb-3" onClick={() => setCurrentPage("home")}>
            &larr; Vissza
          </button>
          <AddEventForm
            currentUser={user}
            onCancel={() => setCurrentPage("home")}
            onSuccess={() => setCurrentPage("home")}
            goHome={() => setCurrentPage("home")}
          />
        </div>
      )}

      {currentPage === "editEvent" && selectedEvent && (
        <div className="container mt-4">
          <button className="btn btn-secondary mb-3" onClick={() => setCurrentPage("home")}>
            &larr; Vissza
          </button>
          <EditEventForm
            event={selectedEvent}
            onCancel={() => setCurrentPage("home")}
            onSuccess={() => setCurrentPage("home")}
          />
        </div>
      )}
    </div>
  );
}

